<template>
  <div
    :class="{
      [$style['v-button']]: true,
      [$style['container']]: hasContainer,
      [$style['disabled']]: disabled,
      [$style['inline']]: inline,
      [$style['selected']]: selected,
      [$style['secondary']]: secondary,
    }"
  >
    <button
      :class="{ [$style['button']]: true, [$style['disabled']]: disabled }"
      v-background-color="backgroundColor"
      @click="handleClick"
    >
      <!-- <img
        v-if="loading"
        class="loader"
        src="@/assets/img/iorder-coreV2/icons/loader-white.svg"
        alt="loading"
      />-->

      <v-loader v-if="loading" :isBlack="!lightLoadingColor" />

      <div v-else-if="tipAmount" :class="$style['content-dual']">
        <span
          v-text="buttonText"
          v-font-style="fontButton"
          :class="{
            [$style['button-text']]: true,
            [$style['lighter']]: tipAmount,
          }"
        />

        <span
          :class="$style['secondary-text']"
          v-font-style="fontButton"
          v-text="`£${tipAmount}`"
        />
      </div>

      <div
        v-else
        :class="{
          [$style['content']]: true,
          [$style['no-padding']]: secondary,
        }"
      >
        <div
          class="v-button__bill-items v-button__bill-items--count"
          :class="$style['bill-items']"
          v-if="billTotal && billQuantity"
        >
          <img
            src="@assets/images/icons/basket.svg"
            alt="back"
            class="back-button__icon"
          />
          <span v-color="colorButtonText" v-font-style="fontButtonSecondary">
            x{{ billQuantity }}
          </span>
        </div>

        <span
          :class="$style['button-text']"
          v-color="colorButtonText"
          v-font-style="fontButton"
          v-text="buttonText"
        />

        <div
          class="v-button__bill-items v-button__bill-items--total"
          v-if="billTotal && billQuantity"
          v-color="colorButtonText"
          v-font-style="fontButtonSecondary"
        >
          <span>£{{ billTotal.toFixed(2) }}</span>
        </div>
        <div class="expandable" v-if="expandable"
          ><img
            src="@assets/images/icons/down-white.svg"
            alt="arrow"
            :class="{ [$style['arrow']]: true, [$style['expanded']]: expand }"
        /></div>
      </div>
    </button>
  </div>
</template>

<script>
import VLoader from '@components/v-loader.vue'

export default {
  components: {
    VLoader,
  },
  props: {
    buttonText: {
      type: String,
      default: '',
    },
    tipAmount: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    lightLoadingColor: {
      type: Boolean,
      default: false,
    },
    billTotal: {
      type: Number,
      default: null,
    },
    billQuantity: {
      type: Number,
      default: null,
    },
    hasContainer: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    colorButton: {
      type: String,
      default: '',
    },
    colorButtonText: {
      type: String,
      default: '',
    },
    colorSelected: {
      type: String,
      default: '',
    },
    fontButton: {
      type: Object,
      default: () => {},
    },
    fontButtonSecondary: {
      type: Object,
      default: () => {},
    },
    secondary: {
      type: Boolean,
      default: false,
    },
    expandable: {
      type: Boolean,
      default: false,
    },
    expand: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    backgroundColor() {
      if (this.selected) {
        return this.colorSelected
      }
      return this.colorButton
    },
  },
  methods: {
    handleClick() {
      this.$emit('buttonClick')
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';

.v-button {
  width: 100%;
  min-height: 48px;
  transition: opacity 0.5s ease;

  &.disabled {
    opacity: 0.4;
    pointer-events: none;

    .button-text {
      opacity: 0.2;
    }
  }

  &.selected {
    .button {
      box-sizing: border-box;
    }
  }

  &.inline {
    height: auto;
  }

  &.container {
    min-height: 64px;
    padding: 8px 16px;
  }

  &.secondary {
    width: 184px;
    min-height: 40px;
  }

  .button {
    border: 0;
    cursor: pointer;
    width: 100%;
    height: 100%;
    border: 2px solid transparent;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 0;

    &:focus {
      outline: 0;
    }
  }

  .content,
  .content-dual {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 0 24px;
    width: 100%;

    &.no-padding {
      padding: 0;
    }
  }

  .content-dual {
    flex-direction: column;
    padding: 0;
  }

  .button-text {
    // font-family: $secondary-body-font;
    font-size: 18px;
    line-height: 1.33;
    color: #fff;
    text-transform: uppercase;
    width: 100%;

    &.lighter {
      font-weight: normal;
      opacity: 0.8;
    }
  }

  .secondary-text {
    color: #fff;
    // font-family: $secondary-body-font;
    font-size: 18px;
  }

  .bill-items {
    align-items: center;
    display: flex;
    // width: 150px;

    img {
      margin-right: 6px;
    }

    span {
      // color: $white;
      font-size: 16px;
      // font-weight: bold;
    }

    &:last-child {
      justify-content: flex-end;
    }
  }

  // .expandable {
  //   padding-top: 2px;
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  // }

  .arrow {
    margin-top: 5px;
    margin-left: 12px;
    transition: transform 0.5s;

    &.expanded {
      transform: rotate(-180deg);
    }
  }
}

// .loader {
//   background-image: url('~/assets/img/iorder-coreV2/icons/loader-white.svg');
// }
</style>
